import { Box, Card, Container } from '@material-ui/core';
import Loader from 'components/AppLoaders/Loader';
import React, { PropsWithChildren } from 'react';
import styles from './SGSPageLoader.module.scss';

type Props = {};

const SGSPageLoader: React.FC<PropsWithChildren<Props>> = () => {
    return (
        <Container className={styles.loaderContainer} style={{ padding: '18px', paddingTop: 0 }}>
            <Card className={styles.loaderCard} style={{ borderRadius: '20px' }}>
                <Box className={styles.loading}>
                    <Box className="mr-5">
                        <Loader loading />
                    </Box>
                    <Box className="m-5 pr-5">Veuillez patienter durant le chargement...</Box>
                </Box>
            </Card>
        </Container>
    );
};

export default SGSPageLoader;
